import { render, staticRenderFns } from "./igt-tab.vue?vue&type=template&id=7810e5d8&scoped=true&"
import script from "./igt-tab.vue?vue&type=script&lang=js&"
export * from "./igt-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7810e5d8",
  null
  
)

export default component.exports